import { NavigationStore } from '../store/navigation-store';
export default class BurgerMenu {
    constructor(container, triggers, name) {
        this.triggers = [];
        this.onStateChange = (state, prevState) => {
            var _a;
            (_a = this.menu) === null || _a === void 0 ? void 0 : _a.classList.toggle('active', state.isActive(this.name));
        };
        this.menu = document.querySelector(container);
        this.triggers = triggers;
        this.name = name;
    }
    init() {
        let elements = [];
        this.triggers.forEach((selector) => {
            elements = elements.concat(Array.from(document.querySelectorAll(selector)));
        });
        elements.forEach((element) => {
            element.addEventListener('click', (event) => this.handleEvent(event));
        });
        NavigationStore.subscribe(this.onStateChange);
    }
    handleEvent(event) {
        NavigationStore.getState().toggle(this.name);
    }
}
